import { Box, Resource, Result } from "@/lib/types";
import { AxiosError } from "axios";
import { media_client } from "../..";

export default {

    async deleteResource(id: number){
        try{

            await media_client.delete(`/resources/`, {
                params: {
                    id
                }
            });
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }
    },
    async editResource(resource: Resource){
        try{

            const response = await media_client.post(`/resources`, {
                resource
            });
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }
    },
    async setThumbnail(id: string, thumbnail: string): Promise<Result<boolean, AxiosError>>{
        try{

            const response = await media_client.post(`/resources/set-thumbnail`, {
                id, thumbnail
            });
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }
    },
    async getSignedUrl(): Promise<Result<{ signed_url: string, filename: string }, AxiosError>>{

        try{

            const response = await media_client.get(`/generic-signed-url`);
            return {
                ok: new Box<{ signed_url: string, filename: string }>({
                    signed_url: response.data.signed_url,
                    filename: response.data.filename
                }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async getByTag(tag: string, start?: string): Promise<Result<{resources: Resource[], next: string}, AxiosError>>{
        
        try{
            
            console.log(`calling ${tag}`)
            const response = await media_client.get('/resources/by-tag', {
                params: {
                    tag, start
                }
            });

            return {
                ok: new Box<{resources: Resource[], next: string}>({
                    resources: response.data.resources as Resource[],
                    next: response.data.next as string
                }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async getByTicket(ticket: string, start?: string): Promise<Result<{resources: Resource[], next: string}, AxiosError>>{
        
        try{
            
            const response = await media_client.get('/resources/by-ticket', {
                params: {
                    ticket, start
                }
            });

            return {
                ok: new Box<{resources: Resource[], next: string}>({
                    resources: response.data.resources as Resource[],
                    next: response.data.next as string
                }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    }
    
}